import { Filter } from "@/common/model/Filter";
import { Nullable } from "@/general/custom-types/CustomTypes";

export class FacilityFilter extends Filter {
  customer: Nullable<number[]>;
  country: Nullable<string>;
  storeNumber: Nullable<string>;
  mall: Nullable<string>;

  constructor(
    customer?: Nullable<number[]>,
    country?: Nullable<string>,
    storeNumber?: Nullable<string>,
    mall?: Nullable<string>
  ) {
    super("facility-filter");
    this.customer = customer;
    this.country = country;
    this.storeNumber = storeNumber;
    this.mall = mall;
  }

  clear(): void {}

  toQueryParam(): string {
    let query: string = "";
    if (this.customer && this.customer.length > 0) {
      query += `&customer=${this.customer}`;
    }
    if (this.country && this.country !== "") {
      query += `&country=${this.country}`;
    }
    if (this.storeNumber && this.storeNumber !== "") {
      query += `&storeNumber=${this.storeNumber}`;
    }
    if (this.mall && this.mall !== "") {
      query += `&mall=${this.mall}`;
    }
    return query;
  }
}
